// import { List, Stack, useTheme } from '@mui/material';
// import { useAuthContext } from 'src/auth/useAuthContext';

// import { NavSectionProps } from '../types';

// import NavList from './NavList';

// // ----------------------------------------------------------------------

// export default function NavSectionVertical({ data, sx, ...other }: NavSectionProps) {
//   const { user } = useAuthContext();

//   const theme = useTheme();
//   const ACCESSIBLE_MENU_URI_LIST = user?.menuList.map((m: any) => m.menuUri);

//   return (
//     <Stack sx={sx} {...other}>
//       {data.map((group) => {
//         const key = group.subheader || group.items[0].title;

//         return (
//           group.items
//             .map((list) => ACCESSIBLE_MENU_URI_LIST.includes(list.path))
//             .includes(true) && (
//             <List
//               key={key}
//               disablePadding
//               sx={{ px: 2, ml: 1, mr: 1, borderBottom: '1px solid ' + theme.palette.divider }}
//             >
//               {/* {group.subheader && (
//                 <StyledSubheader disableSticky>{`${translate(group.subheader)}`}</StyledSubheader>
//               )} */}

//               {group.items.map((list) => {
//                 return (
//                   ACCESSIBLE_MENU_URI_LIST.includes(list.path) && (
//                     <NavList
//                       key={list.title + list.path}
//                       data={list}
//                       depth={1}
//                       hasChild={!!list.children}
//                     />
//                   )
//                 );
//               })}
//             </List>
//           )
//         );
//       })}
//     </Stack>
//   );
// }

import { List, Stack, useTheme } from '@mui/material';
import { useAuthContext } from 'src/auth/useAuthContext';

import { NavSectionProps } from '../types';

import NavList from './NavList';

// ----------------------------------------------------------------------

// 접근 가능한 메뉴가 있는지 재귀적으로 확인하는 함수
function hasAccessibleMenu(list: any, accessiblePaths: string[]): boolean {
  if (accessiblePaths.includes(list.path)) {
    return true;
  }
  if (list.children) {
    return list.children.some((child: any) => hasAccessibleMenu(child, accessiblePaths));
  }
  return false;
}

export default function NavSectionVertical({ data, sx, ...other }: NavSectionProps) {
  const { user } = useAuthContext();
  const theme = useTheme();

  const ACCESSIBLE_MENU_URI_LIST = user?.menuList.map((m: any) => m.menuUri);

  return (
    <Stack sx={sx} {...other}>
      {data.map((group) => {
        const key = group.subheader || group.items[0].title;

        return (
          group.items.some((list) => hasAccessibleMenu(list, ACCESSIBLE_MENU_URI_LIST)) && (
            <List
              key={key}
              disablePadding
              sx={{ px: 2, ml: 1, mr: 1, borderBottom: '1px solid ' + theme.palette.divider }}
            >
              {/* {group.subheader && (
                <StyledSubheader disableSticky>{`${translate(group.subheader)}`}</StyledSubheader>
              )} */}

              {group.items.map((list) => {
                return (
                  hasAccessibleMenu(list, ACCESSIBLE_MENU_URI_LIST) && (
                    <NavList
                      key={list.title + list.path}
                      data={list}
                      depth={1}
                      hasChild={!!list.children}
                    />
                  )
                );
              })}
            </List>
          )
        );
      })}
    </Stack>
  );
}
